<script>
import Vue from 'vue'
// resources
import UnionLocalResource from '../../resources/unionLocal'
import OptionValueResource from '../../resources/optionValue'
import StateResource from '../../resources/state'
import UnionLocationConditionsResource from '../../resources/unionLocationConditions'
import UnionLocationConditionHiredResource from '../../resources/unionLocationConditionHired'
import UnionLocationConditionWorkResource from '../../resources/unionLocationConditionWork'
// components&views
import AutoComplete from '../../components/Autocomplete.vue'
import UnionGrid from '../../components/UnionGrid.vue'
// mixins
import toastMixin from '../../mixins/toast'
import modalMixin from '../../mixins/modal'

export default Vue.extend({
    data() {
        return {
            unionLocalId: '',
            hiredId: '',
            workId: '',
            hiredStates: [],
            workStates: [],
            iteration: 0,
            rowData: [],
        }
    },
    mixins: [toastMixin, modalMixin],
    components: {
        AutoComplete,
        UnionGrid,
    },
    computed: {
        resources() {
            return {
                UnionLocationConditionsResource,
                StateResource,
                OptionValueResource,
                UnionLocalResource,
                UnionLocationConditionHiredResource,
                UnionLocationConditionWorkResource,
            }
        },
    },
    methods: {
        setUnionLocalId(event) {
            if (event && event.id) {
                this.unionLocalId = event.id
            } else {
                this.unionLocalId = null
            }
        },
        async getData() {
            let hiredFromId
            // local hire case
            if (this.hiredId == 80) {
                if (this.workId) {
                    let findWorkState = this.workStates.find((loc) => loc.attributes.id == this.workId)
                    let findOptionValue = this.hiredStates.find((loc) => loc.attributes.code == findWorkState.attributes.code)
                    hiredFromId = findOptionValue.attributes.id
                }
            } else {
                hiredFromId = this.hiredId
            }

            let res = await UnionLocationConditionsResource.list({ query: { union_local_id: this.unionLocalId, hired: hiredFromId, work: this.workId } })
            for (let result of res.resources) {
                await result.resolveRelated()
            }
            this.rowData = res.resources
        },
    },
    async created() {
        let res
        res = await OptionValueResource.list({ query: { option_type_id: 15 } })
        this.hiredStates = res.resources
        res = await StateResource.list()
        this.workStates = res.resources
    },
})
</script>

<template>
    <div class="pageStyling">
        <b-row>
            <b-col cols="2">
                <p>Union Local</p>
                <auto-complete name="union_locals" placeholder="Union Local" :resource-class="this.resources.UnionLocalResource" @select="setUnionLocalId($event)">
                    <template slot="item" slot-scope="option">
                        <p>{{ option.item.name }}</p>
                    </template>
                </auto-complete>
            </b-col>
            <b-col cols="2">
                <p>Hired</p>
                <select class="form-control" id="state" v-model="hiredId">
                    <option value="">Select One</option>
                    <option v-for="item of hiredStates" :value="item.attributes.id" :key="item.attributes.id">
                        {{ item.attributes.code }}
                    </option>
                </select>
            </b-col>
            <b-col cols="2">
                <p>Work</p>
                <select class="form-control" id="state" v-model="workId">
                    <option value="">Select One</option>
                    <option v-for="item of workStates" :value="item.attributes.id" :key="item.attributes.id">
                        {{ item.attributes.code }}
                    </option>
                </select>
            </b-col>
            <b-col>
                <b-button @click="getData">Search</b-button>
            </b-col>
        </b-row>
        <union-grid :row-data="rowData" :key="iteration" class="ag-theme-balham agGrid" />
    </div>
</template>

<style scoped>
.fake-link {
    text-decoration: underline;
    color: blue;
}

.pageStyling {
    margin: 50px 0px 0px 25px;
}

.autocompleteContainer {
    width: 25%;
}

.agGrid {
    margin: 50px 0px 0px 0px;
}

.buttonContainer {
    display: flex;
    margin-top: 20px;
}

.buttonContainer > * {
    margin-right: 20px;
}
</style>
